import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Skeleton } from '@/components/ui/skeleton';

export default function AssignmentCardSkeleton(assignmentCardSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = assignmentCardSkeletonProps;
  return (
    <div
      className={cn(
        'transition-outline border-border-primary bg-background outline-focus-ring flex h-fit flex-col rounded-2xl border outline-0 focus-visible:outline-3 disabled:opacity-75',
        className
      )}
      {...props}
    >
      <div className={'border-border-primary flex items-center gap-3 border-b p-4'}>
        <Skeleton className={'h-4 w-18 rounded-sm'} />
      </div>
      <div className={'flex h-full flex-col gap-3 p-4'}>
        <Skeleton className="h-3 w-3/4 rounded-sm" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-14 rounded-sm" />
          <Skeleton className="h-8 w-16 rounded-sm" />
        </div>
      </div>
    </div>
  );
}
